import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "@/pages/HomePage";
import PedidosPage from "@/pages/PedidosPage";
import InventarioPage from "@/pages/InventarioPage";
import InventarioGeneralPage from "@/pages/InventarioGeneralPage";
import AdminPage from "@/pages/AdminPage";
import TrasladosPage from "@/pages/TrasladosPage";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/pedidos" element={<PedidosPage />} />
        <Route path="/inventario" element={<InventarioPage />} />
        <Route path="/inventario-general" element={<InventarioGeneralPage />} />
        <Route path="/traslados" element={<TrasladosPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;